import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getWorkOrderMonthlyStats } from "../../api/work-orderAPI";

const WorkOrderCompletion = () => {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const stats = await getWorkOrderMonthlyStats();
      if (!stats) return;
      const months = stats.map(item => item.month);
      const createdData = stats.map(item => item.created);
      const completedData = stats.map(item => item.completed);

      setChartSeries([
        { name: "Created", data: createdData },
        { name: "Completed", data: completedData }
      ]);

      setChartOptions({
        legend: { show: false },
        chart: {
          type: "area",
          height: 150,
          toolbar: { show: false },
          padding: { left: 0, right: 0, top: 0, bottom: 0 }
        },
        dataLabels: { enabled: false },
        stroke: {
          curve: "smooth",
          width: 3,
          colors: ["#45B369", "#144BD6"],
          lineCap: "round"
        },
        grid: {
          show: true,
          borderColor: "#D1D5DB",
          strokeDashArray: 1,
          xaxis: { lines: { show: false } },
          yaxis: { lines: { show: true } },
          padding: { top: -20, right: 0, bottom: -10, left: 0 }
        },
        fill: {
          type: "gradient",
          colors: ["#45B369", "#144BD6"],
          gradient: {
            shade: "light",
            type: "vertical",
            opacityFrom: [0.4, 0.6],
            opacityTo: [0.3, 0.3],
            stops: [0, 100]
          }
        },
        markers: {
          colors: ["#45B369", "#144BD6"],
          strokeWidth: 2,
          size: 0,
          hover: { size: 8 }
        },
        xaxis: {
          categories: months,
          labels: { style: { fontSize: "14px" } }
        },
        yaxis: {
          labels: { style: { fontSize: "14px" } }
        },
        tooltip: {
          x: { format: "yyyy-MM" }
        }
      });
    };

    fetchData();
  }, []);

  return (
    <div className='col-xxl-8'>
      <div className='card h-100'>
        <div className='card-body p-24 mb-8'>
          <h6 className="mb-4 fw-bold text-lg">Work Order Completion by Month</h6>
          <div id='revenueChart' className='apexcharts-tooltip-style-1'>
            <ReactApexChart
              options={chartOptions}
              series={chartSeries}
              type='area'
              height={300}
              width={"100%"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderCompletion;
